import { gsap } from "gsap";

import { TextPlugin } from "gsap/TextPlugin";
import useAnimationStore from "../stores/use-animation";
import { useEffect, useRef } from "react";



export default function LogoSvg (props) {
  const timeline = useRef()
  const textTimeline = useRef()
  const { isStart, isShowResult, showResult, isReplaying, restart} = useAnimationStore()

  useEffect(() => {
    gsap.registerPlugin(TextPlugin);
    timeline.current = gsap.timeline({paused: true}).to("#pupil", { scale:20, transformOrigin: "50% 50%"},">")
    textTimeline.current = gsap.timeline({ paused: true}).to("#text-1",{ opacity: 1, delay:4})
    .to("#text-1",{
      duration: 2,
      text: "Hãy suy nghĩ về điều bạn đang phân vân",
      ease: "power1.inOut",
      delay: 1,
    }, ">")
    .to("#text-2",{
      duration: 2,
      text: "Nhấn khi bạn thấy thời điểm thích hợp",
      ease: "power1.inOut",
    }, ">")
    // .eventCallback("onComplete",
    //   () => {
    //     window.addEventListener("click", handleMouseClick)
    //   }
    // )
    return () => {
      timeline.current?.kill()
    }
  }, [])

  useEffect(() => {
    function handleMouseClick  () {
      if (!isStart || isShowResult) return
      timeline.current.play()
      showResult()
    }
    if (isShowResult) return
    if (isStart) {
      textTimeline.current.eventCallback("onComplete",
          () => {
            window.addEventListener("click", handleMouseClick)
          }
        ).restart()

    }
    return () => {
      window.removeEventListener("click", handleMouseClick);
    };

  }, [isStart, isShowResult])
  useEffect(() => {
    if (isReplaying) {
      gsap.delayedCall(3, () => timeline.current.reverse().then(() => {
        restart()
      }));
    }
    else return

    return () => {

    }
  }, [isReplaying])

  return (
    <>
       <svg
      id="logo"
      width={334}
      height={323}
      viewBox="0 0 334 323"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <text id="text-1" x={167} y={40} fontSize={10} textAnchor="middle" fill="#977F07" className="opacity-0 font-[Pacifico]">
        {
          "Yaz yus xhtr ew d@%z bki tobz pwus rgh"
        }
      </text>
      <text id="text-2" x={167} y={280} fontSize={10} textAnchor="middle" fill="#977F07" className="font-[Pacifico]">

      </text>
      <circle
        id="outline"
        cx={167.854}
        cy={161.438}
        r={80.073}
        stroke="#F2E753"
        strokeWidth={3}
      />
      <circle
        id="inline"
        cx={167.854}
        cy={161.438}
        r={80.073}
        stroke="#F2E753"
        strokeWidth={3}
      />
      <circle
        id="outline-2"
        cx={167.854}
        cy={161.438}
        r={80.073}
        stroke="#F2E753"
        strokeWidth={3}
      />
      <g className="top">
        <g className="right">
          <path
            d="M286.711 54.0257C288.007 53.8159 289.167 54.8016 289.091 56.0483L284.947 123.739C284.847 125.371 282.806 126.179 281.528 125.093L215.278 68.7926C214 67.7066 214.62 65.6912 216.317 65.4167L286.711 54.0257Z"
            fill="#C67ED8"
          />
          <rect
            width={40.8069}
            height={98.7895}
            rx={2}
            transform="matrix(0.762011 0.647564 -0.685893 0.727702 253.799 62.8019)"
            fill="#C67ED8"
          />
        </g>
        <g className="mid">
          <path
            d="M160.893 2.05923C161.693 1.01903 163.262 1.01903 164.063 2.05923L208.709 60.067C209.721 61.3821 208.784 63.2868 207.124 63.2868H117.831C116.172 63.2868 115.234 61.3821 116.246 60.067L160.893 2.05923Z"
            fill="#C67ED8"
          />
          <rect
            x={144.52}
            y={29.8778}
            width={41.7302}
            height={105.009}
            rx={2}
            fill="#C67ED8"
          />
        </g>
        <g className="left">
          <path
            d="M43.2027 53.6964C43.1702 52.4501 44.3589 51.5059 45.6451 51.7562L115.597 65.3709C117.285 65.6995 117.84 67.737 116.526 68.7811L48.3364 122.948C47.0221 123.992 45.0079 123.114 44.9654 121.478L43.2027 53.6964Z"
            fill="#C67ED8"
          />
          <rect
            width={40.8762}
            height={98.6196}
            rx={2}
            transform="matrix(0.783016 -0.622001 0.661073 0.750322 47.6233 85.8916)"
            fill="#C67ED8"
          />
        </g>
      </g>
      <g className="bottom">
        <g className="left">
          <path
            d="M46.4399 268.92C45.1434 269.13 43.9835 268.144 44.0598 266.897L48.204 199.206C48.3039 197.575 50.3449 196.767 51.6228 197.853L117.873 254.153C119.151 255.239 118.531 257.255 116.834 257.529L46.4399 268.92Z"
            fill="#C67ED8"
          />
          <rect
            width={40.8069}
            height={98.7895}
            rx={2}
            transform="matrix(-0.762011 -0.647564 0.685893 -0.727702 79.3523 260.144)"
            fill="#C67ED8"
          />
        </g>
        <g className="mid">
          <path
            d="M172.258 320.887C171.458 321.927 169.889 321.927 169.088 320.887L124.442 262.879C123.43 261.564 124.367 259.659 126.027 259.659H215.32C216.979 259.659 217.917 261.564 216.905 262.879L172.258 320.887Z"
            fill="#C67ED8"
          />
          <rect
            x={188.631}
            y={293.068}
            width={41.7302}
            height={105.009}
            rx={2}
            transform="rotate(-180 188.631 293.068)"
            fill="#C67ED8"
          />
        </g>
        <g className="right">
          <path
            d="M289.948 269.249C289.981 270.496 288.792 271.44 287.506 271.19L217.554 257.575C215.866 257.246 215.311 255.209 216.625 254.165L284.814 199.998C286.129 198.954 288.143 199.832 288.185 201.468L289.948 269.249Z"
            fill="#C67ED8"
          />
          <rect
            width={40.8762}
            height={98.6196}
            rx={2}
            transform="matrix(-0.783016 0.622001 -0.661073 -0.750322 285.528 237.054)"
            fill="#C67ED8"
          />
        </g>
      </g>
      <circle
  id="pupil"
  cx="165.247"
  cy="161.247"
  r="22.247"
  fill="#7B76BB"
/>
    </svg>
    </>
  )


}
